/* 运行环境判断，主要为微信侧
*/
const Env = {
  wechatBrowser: false,  //微信环境，含企业微信和小程序
  isWxwork: false,       //企业微信环境
  isWxworkPC: false,     //企业微信PC客户端
  isminiProgram: false,  //小程序环境：
  isDingTalk: false,     //钉钉
};
function detect() {
  return new Promise((resolve, reject) => {
    console.log(reject);
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/micromessenger/) == 'micromessenger') {
      Env.wechatBrowser = true;
    }

    // 企业微信
    if (Env.wechatBrowser && ua.match(/wxwork/) == 'wxwork') {
      Env.isWxwork = true;

      if (ua.match(/windowswechat/) == 'windowswechat') {
        Env.isWxworkPC = true;
      }
    }

    // 小程序环境
    if (Env.wechatBrowser && ua.match(/miniprogram/) == 'miniprogram') {
      Env.isminiProgram = true;
    }

    // 钉钉环境
    if (ua.match(/dingtalk/) == 'dingtalk') {
      Env.isDingTalk = true;
    }

    resolve(Env);
    // if (Env.wechatBrowser && wx && wx.miniProgram) {
    //   wx.miniProgram.getEnv((res) => {
    //     if (res.miniprogram) {
    //       Env.isminiProgram = true;
    //     }
    //     resolve(Env);
    //   });
    // } else {
    //   resolve(Env);
    // }
  });
}
/* 此处使用await封装，确保外面获取到的isminiProgram 是wx.miniProgram.getEnv接口返回的 */
async function autoCallDetect() {
  await detect();
  console.log(Env);
}
autoCallDetect();
export default Env;
